<form class="popupForm" style="min-height: 300px;" [formGroup]="componentForm">
  <div class="common event-view-content" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <ng-container *ngIf="componentForm.get('game_option').value == 'option_1'">{{ 'training_proposal_title' | GetLabelPipe}}</ng-container>
      <ng-container *ngIf="componentForm.get('game_option').value == 'option_2'">{{ 'game_proposal_title' | GetLabelPipe}}</ng-container>
      <ng-container *ngIf="componentForm.get('game_option').value == 'option_3'">{{ 'game_confirmation_title' | GetLabelPipe}}</ng-container>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <ng-container>
      <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important;min-height: 250px;">
        <br/>

        <ng-container *ngIf="!isPlayable">
          {{'vizavi_not_playable' | GetLabelPipe}}
        </ng-container>

        <ng-container *ngIf="isPlayable">
          <mat-radio-group matInput formControlName="game_option" aria-labelledby="example-radio-group-label"
                           class="radio-group">
            <ng-container *ngIf="isTrainer">
              <mat-radio-button class="radio-button" [value]="'option_1'">
                <div class="textCut">
                  🎓 {{'training_proposal_booking' | GetLabelPipe}}
                </div>
              </mat-radio-button>
              <br>
            </ng-container>
            <mat-radio-button class="radio-button" [value]="'option_2'">
              <div class="textCut">
                🎾 {{'record_game_score' | GetLabelPipe}}
              </div>
            </mat-radio-button>
            <br>
            <mat-radio-button class="radio-button" [value]="'option_3'" *ngIf="iAmAlsoTrainer">
              <div class="textCut">
                📆 {{'training_with_client' | GetLabelPipe}}
              </div>
              <!-- DEPRECATED user's games -->
              <div class="textCut" *ngIf="!iAmAlsoTrainer">
                📆 {{'Plan game...' | GetLabelPipe}}
              </div>
            </mat-radio-button>
          </mat-radio-group>
          <div class="event-description" *ngIf="componentForm.get('game_option').value == 'option_1'"
               [innerHTML]="'new_training_description' | GetLabelPipe : -1:null:[profile.shipping_name]">
          </div>
          <div class="event-description" *ngIf="componentForm.get('game_option').value == 'option_2'"
               [innerHTML]="'new_game_confirm_score_description' | GetLabelPipe : -1:null:[profile.shipping_name]">
          </div>
          <div class="event-description" *ngIf="componentForm.get('game_option').value == 'option_3'"
               [innerHTML]="'new_game_plan_game_description' | GetLabelPipe : -1:null:[profile.shipping_name]">
          </div>
        </ng-container>

      </mat-dialog-content>
      <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
        <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
          {{'close'|GetLabelPipe}}
        </button>
        <button type="submit" class="widerButton" mat-raised-button
                *ngIf="isPlayable"
                color="accent"
                (click)="handleSubmit()">
          <mat-icon>3p</mat-icon> {{'continue_in_chat_bot'|GetLabelPipe}}
        </button>
      </div>
    </ng-container>
  </div>
</form>
